type Row = Record<string,unknown>;
type Base = {id:string;version:number;parameter_values:Record<string,string>;
 metadata:{reference_lines?:{code:string;label?:string;unit:string;quantity:number;unit_price:number}[]}};
export type RestoredComposition = {
 configuration:Record<string,string>;
 edits:{code:string;quantity:string;unit_price:string}[];
};
const row=(v:unknown):Row|null=>v && typeof v==="object" && !Array.isArray(v) ? v as Row : null;
const amount=(v:unknown)=>typeof v==="number" && Number.isFinite(v) && v>=0 && v<=1e9;
export function restoreComposition(metadata:unknown,base:Base):
 {data:RestoredComposition|null;reason:string} {
 const snapshot=row(metadata),savedBase=row(snapshot?.article_base);
 if(snapshot?.kind!=="reviewed_article_composition_v1" || !savedBase || savedBase.id!==base.id || savedBase.version!==base.version)
  return {data:null,reason:"A versão guardada não corresponde a esta ficha."};
 const originalParameters=row(savedBase.parameter_values);
 if(!originalParameters || Object.keys(originalParameters).length!==Object.keys(base.parameter_values).length
   || Object.entries(base.parameter_values).some(([key,value])=>originalParameters[key]!==value))
  return {data:null,reason:"Os parâmetros de origem mudaram. Consulte a versão guardada no histórico antes de escolher uma ficha."};
 const original=row(savedBase.metadata)?.reference_lines;
 const source=base.metadata.reference_lines ?? [];
 if(!Array.isArray(original) || original.length!==source.length || !source.length
  || original.some((v,i)=>{const line=row(v),target=source[i];
   return !line || line.code!==target.code || line.unit!==target.unit || line.label!==target.label
    || line.quantity!==target.quantity || line.unit_price!==target.unit_price;}))
  return {data:null,reason:"A composição de origem mudou. A versão guardada continua disponível no histórico."};
 const configuration=row(snapshot.technical_configuration ?? savedBase.parameter_values);
 if(!configuration || Object.values(configuration).some(value=>typeof value!=="string"))
  return {data:null,reason:"A configuração guardada está incompleta ou inválida."};
 const lines=snapshot.lines;
 if(!Array.isArray(lines) || lines.length!==source.length || lines.some((v,i)=>{
  const line=row(v);return !line || (line.code ?? line.key)!==source[i].code || line.unit!==source[i].unit
   || !amount(line.quantity) || !amount(line.unitPrice);
 }))
  return {data:null,reason:"Os recursos guardados não correspondem aos da ficha. Consulte o histórico antes de começar uma nova revisão."};
 return {data:{configuration:configuration as Record<string,string>,
  edits:lines.map((v,i)=>{const line=row(v)!;return {code:source[i].code,quantity:String(line.quantity),unit_price:String(line.unitPrice)};})},reason:""};
}
